export const DROPDOWN_NEXT_RESULT = 'DROPDOWN_NEXT_RESULT';
export const DROPDOWN_PREVIOUS_RESULT = 'DROPDOWN_PREVIOUS_RESULT';
export const DROPDOWN_SET_CONTACTS = 'DROPDOWN_SET_CONTACTS';
export const DROPDOWN_CLEAR_CONTACTS = 'DROPDOWN_CLEAR_CONTACTS';
